export const getMealOptionName = (name: string | null, index: number) => {
  return name || `Option #${index + 1}`;
};
